// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmmodal-inline-1 {
  position: fixed;
  inset: 0;
  background: rgba(15,23,42,.45);
  backdrop-filter: blur(4px);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pmmodal-inline-2 {
  font-family: 'Outfit',sans-serif;
  font-size: 17px;
  font-weight: 700;
}

.pmmodal-inline-3 {
  padding: 18px 22px 22px;
}

.pmmodal-dyn-1 {
  background: var(--pmmodal-1-background);
  border-radius: 18px;
  box-shadow: 0 24px 60px -16px rgba(15,23,42,.2);
  width: var(--pmmodal-1-width);
  max-width: 94vw;
  max-height: 86vh;
  overflow-y: auto;
}

.pmmodal-dyn-2 {
  padding: 18px 22px 14px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background: var(--pmmodal-2-background);
  z-index: 2;
  border-radius: 18px 18px 0 0;
}

.pmmodal-dyn-3 {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: var(--pmmodal-3-background);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--pmmodal-3-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,+CAA+C;EAC/C,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,uCAAuC;EACvC,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B","sourcesContent":[".pmmodal-inline-1 {\n  position: fixed;\n  inset: 0;\n  background: rgba(15,23,42,.45);\n  backdrop-filter: blur(4px);\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pmmodal-inline-2 {\n  font-family: 'Outfit',sans-serif;\n  font-size: 17px;\n  font-weight: 700;\n}\n\n.pmmodal-inline-3 {\n  padding: 18px 22px 22px;\n}\n\n.pmmodal-dyn-1 {\n  background: var(--pmmodal-1-background);\n  border-radius: 18px;\n  box-shadow: 0 24px 60px -16px rgba(15,23,42,.2);\n  width: var(--pmmodal-1-width);\n  max-width: 94vw;\n  max-height: 86vh;\n  overflow-y: auto;\n}\n\n.pmmodal-dyn-2 {\n  padding: 18px 22px 14px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  background: var(--pmmodal-2-background);\n  z-index: 2;\n  border-radius: 18px 18px 0 0;\n}\n\n.pmmodal-dyn-3 {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: none;\n  background: var(--pmmodal-3-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--pmmodal-3-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
